import React from 'react'
import Fiche from '../../Component/Fiche/index'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import Utils from 'EurestoFonction/Utils'

class Add extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      type_produit_id: 0,
      typeContact: Constants.access.CLIENT
    }
  };

  buildEntite = (type_produit_id) => {
    this.setState({
      type_produit_id: type_produit_id,
    })
  }

  render () {
    const type_produit_id = this.state.type_produit_id
    if (type_produit_id > 0) {
      return (
        <Fiche key={Utils.getRandomNumber()} handleAdd={this.props.handleAdd} handleCancel={this.props.handleCancel}
                      typeaction="add" type_produit_id={type_produit_id} data=""/>
      )

    } else {
      return (
        <Grid container style={{margin: 0, padding: 10}} spacing={8} direction="row" justify="center"
              alignItems="center">
          <Grid item style={{margin: 0, padding: 0}} xs
                onClick={() => this.buildEntite(2)}>
            <EurestoDiv title={'Produit à la vente (±FT)'} style={{padding: 0, margin: 0, paddingTop: 10}}>
              <Grid container style={{margin: 0, padding: 10, cursor: 'pointer'}} spacing={0} direction="column" justify="center"
                    alignItems="center">
                <i className="ei-gestion_produit"
                   style={{fontSize: 100, color: EurestoColor('EurestoSecondary')}}
                   aria-hidden="true"/>
              </Grid>
            </EurestoDiv>
          </Grid>
          <Grid item style={{margin: 0, padding: 0}} xs
                onClick={() => this.buildEntite(3)}>
            <EurestoDiv title={'Produit en Stock non Vendus'} style={{padding: 0, margin: 0, paddingTop: 10}}>
              <Grid container style={{margin: 0, padding: 10, cursor: 'pointer'}} spacing={0} direction="column" justify="center"
                    alignItems="center">
                <i className="ei-gestion_produit"
                   style={{fontSize: 100, color: EurestoColor('EurestoSecondary')}}
                   aria-hidden="true"/>
              </Grid>
            </EurestoDiv>
          </Grid>
          <Grid item style={{margin: 0, padding: 0}} xs
                onClick={() => this.buildEntite(5)}>
            <EurestoDiv title={'Fiche Technique de Base'} style={{padding: 0, margin: 0, paddingTop: 10}}>
              <Grid container style={{margin: 0, padding: 10, cursor: 'pointer'}} spacing={0} direction="column" justify="center"
                    alignItems="center">
                <i className="ei-gestion_fiche_technique"
                   style={{fontSize: 100, color: EurestoColor('EurestoSecondary')}}
                   aria-hidden="true"/>
              </Grid>
            </EurestoDiv>
          </Grid>
          <Grid item style={{margin: 0, padding: 0}} xs
                onClick={() => this.buildEntite(4)}>
            <EurestoDiv title={'Cave/Vins'} style={{padding: 0, margin: 0, paddingTop: 10}}>
              <Grid container style={{margin: 0, padding: 10, cursor: 'pointer'}} spacing={0} direction="column" justify="center"
                    alignItems="center">
                <i className="ei-gestion_vin"
                   style={{fontSize: 100, color: EurestoColor('EurestoSecondary')}}
                   aria-hidden="true"/>
              </Grid>
            </EurestoDiv>
          </Grid>
        </Grid>
      )
    }
  }
}

export default Add





// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Page/Ajout/index.js